export default {
  state: {
    geofences: {
      items: [],
      active: {
        stagingLots: [],
        restrictedAreas: [],
        serviceAreas: [],
        loading: false
      },
      loading: false
    }
  },
  mutations: {
    setGeofenceItems (state, value) { state.geofences.items = value },
    setGeofencePricing (state, data) {
      let index = state.geofences.items.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.geofences.items[index][data.field] = data.value
      }
    },
    setGeofenceDriverPay (state, data) {
      let index = state.geofences.items.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.geofences.items[index][data.field] = data.value
      }
    },
    setGeofenceServiceType (state, data) {
      let index = state.geofences.items.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.geofences.items[index].services[data.serviceType][data.field] = data.value
      }
    },
    setGeofenceField (state, data) {
      let index = state.geofences.items.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.geofences.items[index][data.field] = data.value
      }
    },
    setAirportSubgeofence (state, data) {
      let index = state.geofences.items.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.geofences.items[index][data.field] = data.value
      }
    },
    setGeofenceIsP2P (state, data) {
      let index = state.geofences.items.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.geofences.items[index].isP2P = data.value
      }
    },
    setGeofenceActive (state, data) { state.geofences.active[data.field] = data.value },
    setGeofenceActiveLoading (state, value) { state.geofences.active.loading = value },
    setGeofenceLoading (state, value) { state.geofences.loading = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/geofences/geofence-list.js